import type { IntlFormatters } from "@formatjs/intl/src/types";
import { isEnum } from "forms/helpers/checkJsonSchemaType";
import parseEnum from "forms/helpers/parsers/parseEnum";
import type { IProperty } from "types/jsonSchema";
import { z } from "zod";

export default function parseArray(field: IProperty, formatMessage: IntlFormatters["formatMessage"] = () => "") {
    const min = field.minItems ?? 0;

    if (field?.items && isEnum(field.items)) {
        return z.array(parseEnum(field.items, formatMessage)).min(min, {
            error: formatMessage({
                id: "errors.invalid_type_received_null",
            }),
        });
    }

    return z.array(z.any());
}
